module.exports = __webpack_public_path__ + "static/media/ios.855bc55c.png";